import { useMutation } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getExercisesList } from "../queries/exercises";
import { useDisciplineExerciseHook } from "./useExercise";

const useGetAllExercises = () => {
  const { handleSuccess } = useDisciplineExerciseHook();
  const { discipline, module: moduleParam, subject } = useParams();
  const navigate = useNavigate();
  const [initialPage, setInitialPage] = useState<number>();
  const [startTime, setStartTime] = useState<Date>();

  const { mutate, data, isSuccess, isPending } = useMutation({
    mutationKey: ['fetch-discipline-exercises'],
    mutationFn: ({ module, slug }: { module: string, slug: string }) => getExercisesList(module, slug),
    onSuccess: (data) => {
      const { currentIndex, startTime } = handleSuccess(data);

      // Slug atual não existe na lista filtrada — redireciona para o primeiro
      // exercício da lista preservando os search params (filtros).
      if (currentIndex < 0 && data.length > 0 && discipline && moduleParam && subject) {
        const firstSlug = data[0].slug;
        navigate(
          `/disciplinas/${discipline}/modulo/${moduleParam}/assunto/${subject}/exercicio/${firstSlug}${window.location.search}`,
          { replace: true }
        );
        return;
      }

      setInitialPage(currentIndex >= 0 ? currentIndex : 0);
      setStartTime(startTime);
    },
    retry: false,
  });

  return { mutate, data, isSuccess, isPending, initialPage, startTime };
};

export default useGetAllExercises;
